import { render } from "./IntegrationConfig.vue?vue&type=template&id=3aa26c09&scoped=true"
import script from "./IntegrationConfig.vue?vue&type=script&lang=ts"
export * from "./IntegrationConfig.vue?vue&type=script&lang=ts"

import "./IntegrationConfig.vue?vue&type=style&index=0&id=3aa26c09&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3aa26c09"

export default script